import { FC, useCallback, useEffect, useState } from "react"
import { CASE_TYPE } from "../../../core/constants/case.constants"
import { useTranslation } from "react-i18next"
import { connect } from "react-redux"
import {
  matchPath,
  useLocation,
  useParams,
  useSearchParams,
} from "react-router-dom"
import { isEmpty } from "lodash"

import { caseManagement, EArchTreatmentType, preview } from "@/gluelayer"

import {
  UButton,
  UFileBox,
  UFileProcessingCard,
  UModalPopup,
  UText,
} from "../../../components"
import NavigationBlockPopup from "../../../components/NavigationBlockPopup/NavigationBlockPopup"
import Preview from "../../../components/Preview/preview"
import { useAppDispatch, useAppSelector } from "../../../core/app/hooks"
import {
  updateCaseById,
  updateCaseStatus,
  caseConversionAction,
} from "../../../core/app/slices/case/caseThunkApi"
import {
  clinicalRequestBasicType,
  getZipsType,
  UploadZips,
} from "../../../core/app/slices/clinical/clinical.types"
import {
  FILEZIPS,
  setClinicalData,
} from "../../../core/app/slices/clinical/clinicalSlice"
import {
  fetchFileList,
  fetchFileZips,
  forcelockCaseApi,
  lockCaseApi,
  uploadCaseZips,
} from "../../../core/app/slices/clinical/clinicalThunkApi"
import { setIsRouteChangeBlocked } from "../../../core/app/slices/navigationPopup/navigationPopupSlice"
import { RootState } from "../../../core/app/store"
import { useCallbackPrompt } from "../../../hooks/useCallbackPrompt"
import { useMyNavigation } from "../../../hooks/useMyNavigation"
import { ROUTE_ATTENTION_BANNER } from "../../../routes/status.route.config"
import { Box, Grid } from "../../../ui-component/mui.components"
import { CASE_STATUS } from "../../Patient/config/status.config"
import { CASE_ACTION } from "@/core/constants/caseActionType"

import {
  file,
  fileBox,
  fileBoxContent,
  previewBox,
  stltitle,
  title,
  zone,
  zoneBox,
  zoneBoxContainer,
} from "./Scans.style"
import { downloadScan } from "@/core/global/http3Shape"
import { setData, setIsCloseTab } from "@/core/app/slices/patients/patientSlice"
import { requestCloudPresetup } from "@/core/app/slices/v2/v2apis"

/**
 * a component for upload stl & show the teeth model
 * @param downLoadZips: 下载stl文件
 * @param uploadScans: 上传stl文件
 * @param isClickNext: click the next button
 * @returns scans compoent
 */

interface scansType {
  downLoadZips: (payload: object) => any
  setScanErrors: any
  flagClickNext: boolean
  zipList: FileList
  uploadZips: (payload: UploadZips) => any
  current_orgId: string
  steps?: { id: string; lable: string; to: string }[]
  zipNames: []
  getFileName: () => void
  handleSkip: () => void
  handleNext?: () => void
  isRefinement: boolean
  handleLowerStl?: any
  handleUpperStl?: any
  handleShowStl?: any
  caseType: "new_scan" | "hold_scan" | "hold_refinement"
  saveAndContinueLater?: boolean
  setSaveAndContinueLater?: (value: boolean) => void
  setNeedDoPresetup?: (value: boolean) => void
  needDoPresetup?: boolean
}
import { useScannerAccess } from "@/hooks/feature-flags/useScannerAccess"
import { setIsRecordsUpdated } from "@/core/app/slices/uassist/formSlice"
import { downloadAlliedStarFilesbyName } from "@/core/global/httpAlliedstar"
import { downloadSTL, getFileUrl } from "@/core/global/httpMedit"
import useLocalStorageListener from "@/modules/Settings/Integrations/localStorageHooks"
import ScannerPatients from "@/modules/Patient/ScannerPatients/ScannerPatients"
import JSZip from "jszip"
import CaseLockPopup from "@/modules/Clinical/components/CaseLockPopup/caseLockPopup"
import {
  caseLockByCRB,
  caseLockByOtherUser,
  caseLockByShipped,
  caseLockByUassist,
} from "@/modules/Clinical/Treat/column"
import { safeCloseWindow } from "@/core/app/CloseTabContext"
import { convertMBtoKB } from "@/core/utils/formatters"
import { getScannerConnectionStatus } from "@/core/app/slices/integrations"
import { SCANNER_INTEGRATION_IDS } from "@/core/app/slices/integrations/scannerConstants"
import { useEasyRxScansImport } from "./useEasyRxScansImport"

// attention banner scans component
// 这个脚本是从Scans.tsx复制过来的，移除了点next按钮中attention banner不需要的逻辑.
// this script is copied from Scans.tsx, removing the logic that attention banner does not need when clicking the next button.
const AttentionBannerScans: FC = ({
  downLoadZips,
  setScanErrors,
  flagClickNext,
  zipList,
  uploadZips,
  current_orgId,
  steps,
  zipNames,
  getFileName,
  isRefinement,
  handleLowerStl,
  handleUpperStl,
  handleShowStl,
  handleSkip,
  handleNext,
  caseType = "new_scan",
  saveAndContinueLater = false,
  setSaveAndContinueLater,
  setNeedDoPresetup,
  needDoPresetup,
}: scansType) => {
  const MAX_ALLOWED_FILE_SIZE_MB = import.meta.env.VITE_ALLOWED_STL_FILE_SIZE_MB

  const isScannerEnabled = useScannerAccess()
  const { t } = useTranslation("common")

  const [upperStl, setUpperStl] = useState({ data: null, action: "init" })
  const [lowerStl, setLowerStl] = useState({ data: null, action: "init" })
  const [holePopup, setholePopup] = useState(false)
  const [nextPopup, setnextPopup] = useState(false)
  const [showStl, setShowStl] = useState({ isupper: false, islower: false })
  const [scansDownloaded, setScansDownloaded] = useState<boolean>(false)
  const navigate = useMyNavigation()

  const { isRouteChangeBlocked } = useAppSelector(
    (state: RootState) => state.navigationPopup,
  )
  const { caseRAtype } = useAppSelector(
    (state: RootState) => state.udTreatService,
  )
  const [showPrompt, confirmNavigation, cancelNavigation] =
    useCallbackPrompt(isRouteChangeBlocked)

  const { isCloseTab } = useAppSelector(
    (state: RootState) => state.patientService,
  )

  const { caseId, patientId } = useParams()
  const [isShowBothScansPopup, setIsShowBothScansPopup] =
    useState<boolean>(true)
  const { preferences } = useAppSelector((state) => state.userService.user)
  const { caseDetail } = useAppSelector((state: RootState) => state.caseService)
  const { upperType, lowerType, uassist_round } = caseDetail

  const { clinicalSettings } = useAppSelector(
    (state: RootState) => state.userService,
  )

  const { selectedScannerPatient } = useAppSelector(
    (state: RootState) => state.integrationsService,
  )

  const [searchParams] = useSearchParams()
  const mode = searchParams.get("mode")

  const dispatch = useAppDispatch()
  const location = useLocation()

  useEffect(() => {
    return () => {
      setholePopup(false)
      setnextPopup(false)
    }
  }, [])

  useEffect(() => {
    if (!isEmpty(zipList) || uassist_round === undefined) return
    caseType = uassist_round > 0 ? "hold_refinement" : caseType
    console.log("🚀 ~ useEffect ~ rrrrrrrrrrrr caseType:", caseType)

    getFileName({
      patientId,
      caseId,
      caseType,
    })
  }, [uassist_round])

  console.log("ziplist:...........", zipList)

  useEffect(() => {
    if (zipNames.length && isEmpty(zipList)) {
      dispatch(setClinicalData({ isLoading: "pending" }))
      downLoadZips({
        patientId,
        caseId,
        zipNames,
      })
    }
  }, [zipNames])

  const getType = (data: any, type: string) =>
    data && (type === CASE_TYPE.ALIGNER || type === CASE_TYPE.SELFPLAN)
      ? "A"
      : data && type === CASE_TYPE.RETAINER
      ? "R"
      : "--"

  useEffect(() => {
    if (upperStl.data) {
      checkUpperFileUpload({ data: file[0], action: "stl" })
    }
    if (lowerStl.data) {
      checkLowerFileUpload({ data: file[0], action: "stl" })
    }
  }, [upperStl, lowerStl])

  function removeFilesFromZip(zipBlob, filesToRemove) {
    return JSZip.loadAsync(zipBlob).then((zip) => {
      filesToRemove.forEach((file) => zip.remove(file))
      return zip.generateAsync({ type: "blob" })
    })
  }

  // not upload some file in bulk2.zip when case type is selfplan
  function processZips(r) {
    const zips = []
    const tasks = []

    for (const k in r) {
      if (caseRAtype === CASE_TYPE.SELFPLAN && k === "bulk2.zip") {
        const task = removeFilesFromZip(r[k], [
          "Setting Data2/uassist_team_settings.json",
          "Setting Data2/CuttinglineSetting.json",
          "Setting Data2/elasticControlPoints.json",
        ]).then((cleanedZip) => {
          zips.push({ fileName: k, file: cleanedZip })
          console.log("removed files from bulk2.zip for selfplan case type")
        })
        tasks.push(task)
      } else {
        zips.push({ fileName: k, file: r[k] })
      }
    }

    // 等待所有异步删除操作完成
    return Promise.all(tasks).then(() => zips)
  }

  const gotoNextStep = () => {
    dispatch(setClinicalData({ isLoading: "pending" }))
    /**
     * 1. new case: upload all zips
     * 2. on hold new scan: for new requirement dsgn-7015:need to upload all new zips
     * 3. on hold refinement: upload bulk10
     */
    caseManagement
      .saveJsonDataToZip(
        JSON.stringify(clinicalSettings),
        "uassist_team_settings.json",
        "Setting Data2",
      )
      .then(async () => {
        const zip = uassist_round > 0 ? ["bulk10"] : [...FILEZIPS]
        caseManagement.getCaseFiles(zip).then((r) => {
          console.log("🚀 ~ caseManagement.getCaseFiles ~ rrrrr:", r)
          if (r) {
            processZips(r).then(async (zips) => {
              console.log("🚀 ~ processZips ~ zips:", zips)

              const callbackAfterUploadzips = () => {
                handleNext && handleNext()
              }

              await uploadZips({
                zips,
                patientId,
                caseId,
                orgId: current_orgId,
                callback: callbackAfterUploadzips,
              })

              // clear scanner Scans or Attachments
              if (isScannerEnabled) {
                if (
                  Object.keys(caseDetailForShape).length &&
                  caseDetailForShape.Scans
                ) {
                  const detail = JSON.parse(JSON.stringify(caseDetailForShape))
                  detail.Scans = []
                  dispatch(setData({ caseDetailForShape: detail }))
                }
              }
            })
          }
        })
      })
  }

  const checkLowerFileUpload = (file) => {
    handleLowerStl && handleLowerStl(file.action)
  }

  const checkUpperFileUpload = (file) => {
    handleUpperStl && handleUpperStl(file.action)
  }

  const handleNextForFlagClickNext = useCallback(async () => {
    // dispatch(setClinicalData({ isLoading: "pending" }))
    const waitFillHole = async () => {
      return new Promise((resolve) => {
        setTimeout(async () => {
          await preview.fillHole()
          resolve(true)
        }, 500)
      })
    }
    if (typeof flagClickNext === "undefined") return
    if (
      (isRefinement && showStl.isupper && upperStl.data && !showStl.islower) ||
      (isRefinement && showStl.islower && lowerStl.data && !showStl.isupper)
    ) {
      ;(async () => {
        preview.saveArchType(
          upperType === "R"
            ? EArchTreatmentType.Retainer
            : upperType === "A"
            ? EArchTreatmentType.Aligner
            : null,
          lowerType === "R"
            ? EArchTreatmentType.Retainer
            : lowerType === "A"
            ? EArchTreatmentType.Aligner
            : null,
        )
        await caseManagement.saveJsonDataToZip(
          JSON.stringify({ course_check_number: uassist_round }),
          "refinement/arch_data.json",
          "Setting Data10",
        )
        if (caseRAtype === CASE_TYPE.SELFPLAN) {
          waitFillHole()
        }
        preview.saveStlToMtc(upperStl.data, lowerStl.data, isRefinement)
        gotoNextStep()
      })()
    }
    if (
      upperStl.action !== "stl" &&
      upperStl.action !== "download" &&
      lowerStl.action !== "stl" &&
      lowerStl.action !== "download" &&
      !location.pathname.includes(ROUTE_ATTENTION_BANNER.attentionBanner)
    ) {
      setScanErrors(true)
      dispatch(setClinicalData({ isLoading: "idle" }))
      setSaveAndContinueLater?.(false)
      // navigate(steps[1].to)
      return
    }
    if (upperStl.data && lowerStl.data) {
      setScanErrors(false)
      if (caseRAtype === CASE_TYPE.RETAINER) {
        preview.saveArchType(
          EArchTreatmentType.Retainer,
          EArchTreatmentType.Retainer,
        )
      } else {
        preview.saveArchType(
          upperType === "R"
            ? EArchTreatmentType.Retainer
            : upperType === "A"
            ? EArchTreatmentType.Aligner
            : null,
          lowerType === "R"
            ? EArchTreatmentType.Retainer
            : lowerType === "A"
            ? EArchTreatmentType.Aligner
            : null,
        )
      }
      if (caseRAtype === CASE_TYPE.SELFPLAN) {
        await waitFillHole()
      }
      preview.saveStlToMtc(upperStl.data, lowerStl.data, uassist_round > 0)
      gotoNextStep()
    } else if (
      (upperStl.data || lowerStl.data) &&
      !location.pathname.includes(ROUTE_ATTENTION_BANNER.attentionBanner)
    ) {
      setScanErrors(false)
      if (caseRAtype === CASE_TYPE.RETAINER) {
        preview.saveArchType(
          EArchTreatmentType.Retainer,
          EArchTreatmentType.Retainer,
        )
      } else {
        preview.saveArchType(
          upperType === "R"
            ? EArchTreatmentType.Retainer
            : upperType === "A"
            ? EArchTreatmentType.Aligner
            : null,
          lowerType === "R"
            ? EArchTreatmentType.Retainer
            : lowerType === "A"
            ? EArchTreatmentType.Aligner
            : null,
        )
      }

      if (caseRAtype === CASE_TYPE.SELFPLAN) {
        await waitFillHole()
      }

      preview.saveStlToMtc(upperStl.data, lowerStl.data, uassist_round > 0)
      if (preferences?.on_show_both_scan_upload_warning) {
        gotoNextStep()
      } else {
        dispatch(setClinicalData({ isLoading: "idle" }))
        setnextPopup(true)
      }
    } else if (
      (location.pathname.includes(ROUTE_ATTENTION_BANNER.attentionBanner) &&
        showStl.isupper &&
        upperStl.data) ||
      (location.pathname.includes(ROUTE_ATTENTION_BANNER.attentionBanner) &&
        showStl.islower &&
        lowerStl.data)
    ) {
      preview.saveArchType(
        upperType === "R"
          ? EArchTreatmentType.Retainer
          : upperType === "A"
          ? EArchTreatmentType.Aligner
          : null,
        lowerType === "R"
          ? EArchTreatmentType.Retainer
          : lowerType === "A"
          ? EArchTreatmentType.Aligner
          : null,
      )
      if (caseRAtype === CASE_TYPE.SELFPLAN) {
        waitFillHole()
      }
      preview.saveStlToMtc(upperStl.data, lowerStl.data, uassist_round > 0)
      setScanErrors(false)
      gotoNextStep()
    } else {
      setScanErrors(!scansDownloaded)
      !scansDownloaded && handleSkip && handleSkip()
      if (!location?.pathname.includes(ROUTE_ATTENTION_BANNER.attentionBanner))
        navigate(steps[1].to)
    }
  }, [flagClickNext])

  useEffect(() => {
    handleNextForFlagClickNext()
  }, [flagClickNext])

  useEffect(() => {
    if (upperStl.action === "stl" || lowerStl.action === "stl") {
      dispatch(setIsRouteChangeBlocked({ isRouteChangeBlocked: true }))
    } else {
      dispatch(setIsRouteChangeBlocked({ isRouteChangeBlocked: false }))
    }
  }, [upperStl, lowerStl])

  useEffect(() => {
    if (caseDetail) {
      if (isRefinement) {
        setShowStl({
          isupper: true,
          islower: true,
        })
        return
      }
      const udesignCategory = caseDetail?.udesign_category
      if (udesignCategory) {
        const arches = udesignCategory.split("/")
        setShowStl({
          isupper: arches[0].includes("R") || arches[0].includes("A"),
          islower: arches[1].includes("R") || arches[1].includes("A"),
        })
      }
    }
  }, [caseDetail])

  useEffect(() => {
    handleLowerStl && handleShowStl(showStl)
  }, [showStl])

  const { caseDetailForShape, scannerSelect } = useAppSelector(
    (state: RootState) => state.patientService,
  )
  const { connectionStatus } = useAppSelector(
    (state: RootState) => state.integrationsService,
  )
  useEffect(() => {
    dispatch(getScannerConnectionStatus())
  }, [dispatch])

  const { importEasyRxScans } = useEasyRxScansImport({
    onUpperStl: (file) => {
      dispatch(setIsRecordsUpdated(true))
      const stl = { data: file, action: file ? "stl" : "delete" }
      setUpperStl(stl)
      checkUpperFileUpload(stl)
      if (file) setScanErrors(false)
      setNeedDoPresetup?.(true)
    },
    onLowerStl: (file) => {
      dispatch(setIsRecordsUpdated(true))
      const stl = { data: file, action: file ? "stl" : "delete" }
      setLowerStl(stl)
      checkLowerFileUpload(stl)
      if (file) setScanErrors(false)
      setNeedDoPresetup?.(true)
    },
  })

  // download stls from scanner
  useEffect(() => {
    if (isScannerEnabled) {
      if (
        scannerSelect === "3Shape" &&
        caseDetailForShape.Scans &&
        caseDetailForShape.Scans.length
      ) {
        if (caseDetailForShape.upper) {
          downloadScan(
            caseDetailForShape.upper,
            "upper.stl",
            null,
            dispatch,
          ).then((res) => {
            if (!res) return
            setUpperStl({ data: res, action: "stl" })
            checkUpperFileUpload({ data: res, action: "stl" })
          })
        }
        if (caseDetailForShape.lower) {
          downloadScan(
            caseDetailForShape.lower,
            "lower.stl",
            null,
            dispatch,
          ).then((res) => {
            if (!res) return
            setLowerStl({ data: res, action: "stl" })
            checkLowerFileUpload({ data: res, action: "stl" })
          })
        }
      } else if (
        scannerSelect === "Alliedstar" &&
        caseDetailForShape.Scans &&
        caseDetailForShape.Scans.length &&
        caseDetailForShape.Info
      ) {
        downloadAlliedStarFilesbyName(
          caseDetailForShape.Info.CaseId,
          ["upper.stl", "lower.stl"],
          dispatch,
        ).then((res) => {
          if (res && res.upper) {
            setUpperStl({ data: res.upper, action: "stl" })
            checkUpperFileUpload({ data: res.upper, action: "stl" })
          }
          if (res && res.lower) {
            setLowerStl({ data: res.lower, action: "stl" })
            checkLowerFileUpload({ data: res.lower, action: "stl" })
          }
        })
      } else if (
        scannerSelect === "Medit" &&
        caseDetailForShape.Scans &&
        caseDetailForShape.Scans.length &&
        caseDetailForShape.Info
      ) {
        //
        console.log("🚀 caseDetailForShape:", caseDetailForShape)
        const upkeywords = ["maxillary"]
        const lowkeywords = ["mandibular"]
        let hasUpper = false,
          haLower = false
        caseDetailForShape.Scans.forEach((scan) => {
          if (
            upkeywords.some((keyword) => scan.name.includes(keyword)) &&
            !hasUpper
          ) {
            hasUpper = true
            getFileUrl(scan.uuid).then((res) => {
              if (res) {
                downloadSTL(res, "upper.stl", dispatch).then((file) => {
                  if (file) {
                    setUpperStl({ data: file, action: "stl" })
                    checkUpperFileUpload({ data: file, action: "stl" })
                  }
                })
              }
            })
          }
          if (
            lowkeywords.some((keyword) => scan.name.includes(keyword)) &&
            !haLower
          ) {
            haLower = true
            getFileUrl(scan.uuid).then((res) => {
              if (res) {
                downloadSTL(res, "lower.stl", dispatch).then((file) => {
                  if (file) {
                    setLowerStl({ data: file, action: "stl" })
                    checkLowerFileUpload({ data: file, action: "stl" })
                  }
                })
              }
            })
          }
        })
      }
    }
  }, [caseDetailForShape])

  // locastorage key  3shapeData， meditData, alliesData
  const shapeLocal = useLocalStorageListener("3shapeData", null)
  const meditDataLocal = useLocalStorageListener("meditData", null)
  const alliesDataLocal = useLocalStorageListener("alliesData", null)
  const [scannerListData, setScannerListData] = useState([])
  // gei scanner list
  useEffect(() => {
    const tmp = []
    if (shapeLocal) {
      tmp.push({
        name: "3Shape",
        key: "3Shape",
      })
    }
    if (meditDataLocal) {
      tmp.push({
        name: "Medit",
        key: "Medit",
      })
    }
    if (alliesDataLocal) {
      tmp.push({
        name: "Alliedstar",
        key: "Alliedstar",
      })
    }
    setScannerListData(tmp)
  }, [shapeLocal, meditDataLocal, alliesDataLocal])
  // scanner patients box
  const [showScannerPatients, setShowScannerPatients] = useState<boolean>(false)

  const showImportScannerPatients = isScannerEnabled && (Object.values(connectionStatus).some(Boolean))

  /********lock case*********/
  let clickWho = ""
  // case lock popup
  const [openLockPopup, setOpenLockPopup] = useState<boolean>(false)
  // case lock type
  //-1--- CRB  ,0---lock by uassist,   1---order been place, 0.5---order been place close case ,  2----edit by other user  ,
  const [lockType, setLockType] = useState<number>(2)
  const [allowUnlock, setAllowUnlock] = useState(true)
  // lock by username and machine
  const [lockInfo, setLockInfo] = useState<{
    username: string
    device_info: string
    locked_date: string
  }>({ username: "", device_info: "", locked_date: "" })
  let lockPopupTakeControlCallback = () => {}
  /**
   * lock popup confirm override function
   */
  const lockPopupConfirm = () => {
    // click lock control or override button
    const clickControlOverride = (overrideCallBak?: () => void) => {
      dispatch(forcelockCaseApi({ patientId, caseId })).then(({ payload }) => {
        const { status } = payload
        if (status === "Success") {
          setOpenLockPopup(false)

          overrideCallBak && overrideCallBak()
          // continue the next action
          lockPopupTakeControlCallback && lockPopupTakeControlCallback()
        }
      })
    }

    if (lockType === 3) {
      clickControlOverride(() => {
        // uploadAllData({
        //   callback: () => {
        //     dispatch(unlockCaseApi({ patientId, caseId })).then(async () => {
        //       await dispatch(setSwitchViewEdit(false))
        //       setOpenLockPopup(false)
        //       safeCloseWindow()
        //     })
        //   },
        // })
      })
    } else {
      clickControlOverride()
    }
    // const urlParams = new URLSearchParams(window.location.search)
    // const doRefinement = urlParams.get("doRefinement")
    // if (doRefinement=="true") {
    //   treatView.startSplitScreenToCreateRefinement()
    //   dispatch(setIsCreateNewRefinement(true))
    //   dispatch(setStageShowType("compare"))
    // }
  }

  // lock post request
  const lockFunc = (callBack?: () => void, allowControl = true) => {
    dispatch(lockCaseApi({ patientId, caseId })).then(({ payload }) => {
      const { status } = payload
      if (status === "Success") {
        callBack && callBack()
      } else {
        const { errors, username, device_info, locked_date } = payload.data
        const { error_message } = errors[0]
        const info = error_message.split("::")[0]
        if (caseLockByUassist.includes(info)) {
          setLockType(0)
          setAllowUnlock(allowControl)
          setOpenLockPopup(true)
        } else if (caseLockByShipped.includes(info)) {
          // if (clickWho === "close" && switchViewEdit) {
          //   setLockType(0.5)
          //   clickWho = ""
          // } else {
          //   setLockType(1)
          // }
          setLockType(1)
          setAllowUnlock(allowControl)
          setOpenLockPopup(true)
        } else if (caseLockByOtherUser.includes(info)) {
          setLockInfo({ username, device_info, locked_date })
          // const lockType = switchViewEdit
          //   ? clickWho === "close" || clickWho === "order"
          //     ? 3
          //     : 2
          //   : 2
          const lockType = 2
          console.log("lock case payload:", lockType, clickWho)
          setLockType(lockType)
          if (lockType === 2) {
            lockPopupTakeControlCallback = callBack
          }
          setAllowUnlock(allowControl)
          setOpenLockPopup(true)
        } else if (caseLockByCRB.includes(info)) {
          setLockType(-1)
          setAllowUnlock(allowControl)
          setOpenLockPopup(true)
        }
      }
      clickWho = ""
    })
  }
  return (
    <>
      <Grid>
        <UModalPopup
          sxModalProps={{
            ".MuiDialog-paper": {
              maxWidth: 444,
            },
            "#titleCntr": {
              padding: "16px 24px",
            },
            "#contentCntr": {
              padding: "20px 24px",
              height: 192,
            },
            "#btnListCntr": {
              padding: 1,
              gap: 1,
            },
          }}
          title={
            <UText variant={"h6"}>{t("records.scans.holePopupTile")}</UText>
          }
          content={
            <Box>
              <span>{t("records.scans.holePopup1")}</span>
              <br />
              <br />
              <span>{t("records.scans.holePopup2")}</span>
            </Box>
          }
          isAlert={holePopup}
          btnList={[
            <UButton
              variant={"contained"}
              btnText={t("button.ok")}
              sxProp={{ width: 53, height: 36 }}
              key={"hole"}
              onClickHandler={() => setholePopup(false)}
            />,
          ]}
        />
        <UModalPopup
          sxModalProps={{
            ".MuiDialog-paper": {
              maxWidth: 444,
            },
            "#titleCntr": {
              padding: "16px 24px",
            },
            "#contentCntr": {
              padding: "20px 24px",
              // height: 182,
            },
            "#btnListCntr": {
              padding: 1,
              gap: 1,
            },
          }}
          title={
            <UText variant={"h6"}>{t("records.scans.nextPopupTile")}</UText>
          }
          content={
            <>
              <Grid container flexDirection={"column"}>
                <UText variant={"body1"}>
                  {t("records.scans.nextPopup1")}
                  <br />
                  <br />
                  {t("records.scans.nextPopup2")}
                </UText>
              </Grid>
              {/* <Grid sx={{ height: 38 }}>
              <Checkbox
                onChange={({ target: { checked } }) => {
                  if (checked) {
                    dispatch(
                      updateUserPreferences({
                        on_show_both_scan_upload_warning: true,
                      }),
                    )
                  } else {
                    dispatch(
                      updateUserPreferences({
                        on_show_both_scan_upload_warning: false,
                      }),
                    )
                  }
                }}
              />
              <UText variant={"body1"}>{t("popup.showAgain")}</UText>
            </Grid> */}
            </>
          }
          isAlert={
            (isShowBothScansPopup && nextPopup && !isRefinement) ||
            (isShowBothScansPopup &&
              nextPopup &&
              isRefinement &&
              showStl.islower &&
              showStl.isupper)
          }
          btnList={[
            <UButton
              variant={"contained"}
              btnText={"YES"}
              key={"yes"}
              sxProp={{ minWidth: 58, height: 36 }}
              onClickHandler={gotoNextStep}
            />,
            <UButton
              variant={"shade"}
              btnText={"NO"}
              key={"no"}
              onClickHandler={() => {
                setSaveAndContinueLater?.(false)
                setnextPopup(false)
              }}
              sxProp={{ minWidth: 54, height: 36 }}
            />,
          ]}
        />
        <UText sxProp={title} variant={"h5"}>
          {t("records.scans.title")}
        </UText>
        {isRefinement && (
          <UText
            variant="caption"
            sxProp={{
              display: "flex",
              justifyContent: "center",
              color: "#616161",
            }}
          >
            {t("records.refinement.description")}
          </UText>
        )}
        <Grid container sx={previewBox}>
          <Box
            style={{
              ...fileBox,
              ...(showImportScannerPatients ? { padding: "0 0 32px 0" } : {}),
            }}
          >
            {((isRefinement && showStl.isupper) ||
              (location.pathname.includes(
                ROUTE_ATTENTION_BANNER.attentionBanner,
              ) &&
                showStl.isupper) ||
              (!isRefinement &&
                !location.pathname.includes(
                  ROUTE_ATTENTION_BANNER.attentionBanner,
                ))) && (
              <Grid sx={{ ...zone }}>
                <UText
                  sxProp={{
                    ...stltitle,
                  }}
                  variant={"h6"}
                >
                  {"Upper"}
                </UText>
                {upperStl.action === "stl" || upperStl.action === "download" ? (
                  <UFileProcessingCard
                    fileName={
                      upperStl.action === "stl"
                        ? upperStl.data?.name
                        : "Uploaded Scan"
                    }
                    fileSize={upperStl.data?.size}
                    progressValue={100}
                    progressstatus={"complete"}
                    onRemove={() => {
                      dispatch(setIsRecordsUpdated(true))
                      setUpperStl({ data: null, action: "delete" })
                      checkUpperFileUpload({ data: null, action: "delete" })
                      //clear scanner detail
                      dispatch(setData({ caseDetailForShape: {} }))
                      setNeedDoPresetup(true)
                    }}
                    removable={
                      (caseDetail &&
                        caseDetail.caseDisposition !== CASE_STATUS.ACTIVE) ||
                      caseRAtype == CASE_TYPE.SELFPLAN
                    }
                  ></UFileProcessingCard>
                ) : (
                  <UFileBox
                    id={"Upper"}
                    allowedFileExtensions={[
                      "vnd.ms-pki.stl",
                      "stl",
                      "sla",
                      "mtc",
                    ]}
                    allowedfileSize={convertMBtoKB(MAX_ALLOWED_FILE_SIZE_MB)}
                    selectedFile={(file) => {
                      setScanErrors(false)
                      dispatch(setIsRecordsUpdated(true))
                      setUpperStl({ data: file[0], action: "stl" })
                      checkUpperFileUpload({ data: file[0], action: "stl" })
                      //clear scanner detail
                      dispatch(setData({ caseDetailForShape: {} }))
                      setNeedDoPresetup(true)
                    }}
                    fileAcceptType={
                      ".stl,.mtc,model/stl,application/sla,application/vnd.ms-pki.stl"
                    }
                    boxSize={file}
                    fileBoxContent={fileBoxContent}
                    isRequired={false}
                    messages={{
                      fileNote: t("records.scans.fileNote"),
                      uploadButton: t("records.scans.uploadButton"),
                      uploadButtonSuffix: t("records.scans.uploadButtonSuffix"),
                      invalidfileFormat: t("records.scans.invalidfileFormat"),
                      invalidFileSize: t(
                        "records.scans.invalidSTLFileSizeLimit",
                        {
                          maxStlFileSizeLimit: MAX_ALLOWED_FILE_SIZE_MB,
                        },
                      ),
                    }}
                    fileLimit={1}
                  ></UFileBox>
                )}
              </Grid>
            )}
            {((isRefinement && showStl.islower) ||
              (location.pathname.includes(
                ROUTE_ATTENTION_BANNER.attentionBanner,
              ) &&
                showStl.islower) ||
              (!isRefinement &&
                !location.pathname.includes(
                  ROUTE_ATTENTION_BANNER.attentionBanner,
                ))) && (
              <Grid sx={{ ...zone }}>
                <UText sxProp={{ ...stltitle }} variant={"h6"}>
                  {"Lower"}
                </UText>
                {lowerStl.action === "stl" || lowerStl.action === "download" ? (
                  <UFileProcessingCard
                    fileName={
                      lowerStl.action === "stl"
                        ? lowerStl.data?.name
                        : "Uploaded Scan"
                    }
                    fileSize={lowerStl.data?.size}
                    progressValue={100}
                    progressstatus={"complete"}
                    onRemove={() => {
                      dispatch(setIsRecordsUpdated(true))
                      setLowerStl({ data: null, action: "delete" })
                      checkLowerFileUpload({ data: null, action: "delete" })
                      //clear scanner detail
                      dispatch(setData({ caseDetailForShape: {} }))
                      setNeedDoPresetup(true)
                    }}
                    removable={
                      (caseDetail &&
                        caseDetail.caseDisposition !== CASE_STATUS.ACTIVE) ||
                      caseRAtype == CASE_TYPE.SELFPLAN
                    }
                  ></UFileProcessingCard>
                ) : (
                  <UFileBox
                    id={"Lower"}
                    allowedFileExtensions={[
                      "vnd.ms-pki.stl",
                      "stl",
                      "sla",
                      "mtc",
                    ]}
                    allowedfileSize={convertMBtoKB(MAX_ALLOWED_FILE_SIZE_MB)}
                    selectedFile={(file) => {
                      setScanErrors(false)
                      dispatch(setIsRecordsUpdated(true))
                      setLowerStl({ data: file[0], action: "stl" })
                      checkLowerFileUpload({ data: file[0], action: "stl" })
                      //clear scanner detail
                      dispatch(setData({ caseDetailForShape: {} }))
                      setNeedDoPresetup(true)
                    }}
                    fileAcceptType={
                      ".stl,.mtc,model/stl,application/sla,application/vnd.ms-pki.stl"
                    }
                    boxSize={file}
                    fileBoxContent={fileBoxContent}
                    isRequired={false}
                    messages={{
                      fileNote: t("records.scans.fileNote"),
                      uploadButton: t("records.scans.uploadButton"),
                      uploadButtonSuffix: t("records.scans.uploadButtonSuffix"),
                      invalidfileFormat: t("records.scans.invalidfileFormat"),
                      invalidFileSize: t(
                        "records.scans.invalidSTLFileSizeLimit",
                        {
                          maxStlFileSizeLimit: MAX_ALLOWED_FILE_SIZE_MB,
                        },
                      ),
                    }}
                    fileLimit={1}
                  ></UFileBox>
                )}
              </Grid>
            )}
            {showImportScannerPatients && (
              <UButton
                sxProp={{ mt: 0, height: "36px", margin: "10px" }}
                variant={"contained"}
                btnType={"text"}
                btnText={`Import scans`}
                onClickHandler={() => {
                  setShowScannerPatients(true)
                }}
              />
            )}
          </Box>
          <Box style={zoneBoxContainer}>
            <Box style={zoneBox}>
              <Preview
                upperStl={upperStl}
                lowerStl={lowerStl}
                fillholeCallback={(isSuccess: boolean) => {
                  if (!isSuccess) {
                    setholePopup(true)
                  }
                }}
                placeHolder={t("records.scans.previewPlaceHolder")}
                zips={zipList}
                setUpperStl={setUpperStl}
                setLowerStl={setLowerStl}
                isShowRefinement={uassist_round > 0}
              />
              {/* {isRefinement ? (
                <Refinement
                  upperStl={upperStl}
                  lowerStl={lowerStl}
                  placeHolder={t("records.scans.previewPlaceHolder")}
                  zips={zipList}
                  setUpperStl={setUpperStl}
                  setLowerStl={setLowerStl}
                ></Refinement>
              ) : (
                <Preview
                  upperStl={upperStl}
                  lowerStl={lowerStl}
                  fillholeCallback={(isSuccess: boolean) => {
                    if (!isSuccess) {
                      setholePopup(true)
                    }
                  }}
                  placeHolder={t("records.scans.previewPlaceHolder")}
                  zips={zipList}
                  setUpperStl={setUpperStl}
                  setLowerStl={setLowerStl}
                  isShowRefinement={isShowRefinement}
                />
              )} */}
            </Box>
          </Box>
        </Grid>
      </Grid>
      <NavigationBlockPopup
        cancelNavigation={() => {
          dispatch(setIsCloseTab(false))
          cancelNavigation()
        }}
        confirmNavigation={() => {
          if (isCloseTab) {
            safeCloseWindow()
          } else {
            confirmNavigation()
          }
        }}
        showPrompt={showPrompt}
      />
      {showImportScannerPatients && (
          <ScannerPatients
            showScannerPatients={showScannerPatients}
            setShowScannerPatients={setShowScannerPatients}
            hideScanners={true}
            handleScannerPatientDetailSelect={(rowInfo) => {
              const externalCaseId = rowInfo.CaseId
              setShowScannerPatients(false)
              dispatch(
                updateCaseById({
                  patientId,
                  caseId,
                  payload: {
                    extra_info: JSON.stringify({
                      ...caseDetail?.extra_info,
                      scanner: { name: selectedScannerPatient?.scanner, id: Number(externalCaseId) },
                    }),
                  },
                }),
              ).then(() => {
                importEasyRxScans(externalCaseId)
              })
            }}
          />
        )}
      {/* case lock popup */}
      <CaseLockPopup
        lockType={lockType}
        openLockPopup={openLockPopup}
        setOpenLockPopup={setOpenLockPopup}
        lockInfo={lockInfo}
        clickControlOverride={lockPopupConfirm}
        allowControl={allowUnlock}
        cancelNavigation={cancelNavigation}
      />
    </>
  )
}

export default connect(
  ({ clinicalService, userService }) => {
    const { zipList, zipNames } = clinicalService
    const {
      user: { current_orgId },
    } = userService
    return { zipList, current_orgId, zipNames }
  },
  (dispatch) => {
    return {
      getFileName: ({
        patientId,
        caseId,
        caseType,
      }: clinicalRequestBasicType) => {
        const zip =
          caseType === "new_scan"
            ? [...FILEZIPS]
            : caseType === "hold_refinement"
            ? ["bulk10"]
            : ["raw"]
        console.log("fetchFileList::", zip)
        dispatch(
          fetchFileList({
            patientId,
            caseId,
            fileNames: zip,
          }),
        )
      },
      downLoadZips: ({ orgId, patientId, caseId, zipNames }: getZipsType) => {
        console.log("download zip::", zipNames)
        return dispatch(
          fetchFileZips({
            orgId,
            patientId,
            caseId,
            zipNames,
          }),
        )
      },
      uploadZips: async (payload: UploadZips) => {
        return dispatch(uploadCaseZips({ ...payload }))
      },
    }
  },
)(AttentionBannerScans)
